<!-- 文章详情 -->
<template>
	<div class="exclusiveView-details max-content">

		<div class="introduction">
			<!-- <div class="cover">
				<img :src="articleInfo.banner" alt="">
			</div> -->
			<div class="writerInfoWrap">
				<h3>{{ articleInfo.name }}</h3>
				<p v-if="articleInfo.show_read" style="color:gray">观看人次{{ articleInfo.read }}</p>
				<!-- <div class="flexRow-between-center">
					<div class="writerInfo">
							<img :src="expertInfo.photo" alt="" onerror="common.imgError(1,event)" v-if="articleInfo.photo">
							<img src="../../assets/images/defaultHead.png" alt="" v-if="articleInfo.photo==null">
						<div class="info">
							<p>{{writers.name}} {{writers.positionName}}</p>
							<p>{{writers.company}}</p>
						</div>
					</div>
					<div class="time">
						<div class="operation">
							<div class="attention" @click="collectArticles" v-if="articleInfo.is_follow==0">收藏</div>
							<div class="attention" @click="collectArticles" v-if="articleInfo.is_follow==1">取消收藏</div>
						</div>
					</div>
				</div> -->

			</div>
		</div>
		<div class="articleContent" v-html="articleInfo.content" v-if="articleInfo.content" ref="richTextContainer">
		</div>
		<div class="imagesWrap">
			<img :src="item.img" alt="" v-for="(item) in articlesImageData" :key="item.id">
			<!-- <a @click="downloadLink(articleInfo.bind_url)" v-if="articleInfo.type==2" class="downloadLink" download>下载链接</a> -->
			<!-- <p class="downloadLink">若您需下载该病例，请点击<a @click="downloadLink(articleInfo.bind_url)">此处</a>进行下载。</p> -->
		</div>
		<div class="hr-7"></div>
		<div class="comment" v-if="commentList.length > 0">
			<h3>{{ commentList.length }}条评论</h3>
			<div class="comment-item" v-for="(item, index) in commentList" :key="index">
				<img :src="item.user.avatar" alt="">
				<div class="commentContent">
					<div class="readerInfo">
						<span>{{ item.user.nickName }}</span>
						<p>{{ item.created_at }}</p>
					</div>
					<div class="content">
						<p>{{ item.content }}</p>
					</div>
				</div>
			</div>

		</div>
		<div class="recommends" v-if="recommends.length > 0">
			<p>RECOMMEND</p>
			<p>推荐阅读</p>
			<div v-for="(item, index) in recommends" :key="index">
				<a :href="'/video?id=' + item.id" v-if="item.type == 3">{{ item.name }}</a>
				<a :href="'/exclusiveView/details?article_id=' + item.id" v-else>{{ item.name }}</a>
			</div>
		</div>
		<div class="fixedImg">
			<!-- 	<div class="message">
				<img src="../../assets/images/Meeting/Meeting_message.png" alt="">
			</div> -->
			<!-- <div class="share">
				<img src="../../assets/images/Meeting/Meeting_share.png" alt="">
			</div> -->
		</div>
		<div class="comment-input max-content">
			<input type="text" placeholder="写评论..." ref="commentInput" v-model="content">
			<button @click="sendComment">发送</button>
		</div>
	</div>
</template>
<script>
import { Dialog } from 'vant';
import { ArticlesImage, ArticlesDetails, ArticlesAddComment, ArticlesComments, ArticlesLength, ArticlesCollect, articleRecommend } from '../../config/interface.js'
export default {
	data() {
		return {
			article_id: 0,
			length: 0,
			articleInfo: {},
			writers: {},
			content: '',
			userInfo: this.$store.state.userInfo,
			commentList: [],   //评论列表
			column_id: 0,    //专栏id
			articlesLength: 0,	//文章长度
			articlesImageData: [],
			articleType: 0,			//文章类型
			recommends: []
		}
	},
	beforeRouteEnter(to, from, next) {
		//  修复iOS版微信HTML5 History兼容性问题
		if (to.path !== location.pathname) {
			location.assign(to.fullPath)
		} else {
			next()
		}
	},
	mounted() {
		this.article_id = this.$route.query.article_id;
		this.column_id = this.$route.query.column_id ? this.$route.query.column_id : 0;
		this.init();
		this.getArticleImages();
		this.checkComments();
		this.getRecommends();
		this.column_id != 0 || this.column_id == undefined ? this.getArticlesLength() : '';
		if (this.article_id == 4110) {
			document.title = 'Htology血液前沿'
		}


	},
	methods: {
		//初始化
		init() {
			const url = ArticlesDetails;
			const method = 'POST';
			let params = {
				article_id: this.article_id

			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.articleInfo = data;
						//微信浏览器  请求jsdk
						if (common.is_weixin()) {
							common.wxShare(data.name, data.des, data.share_pic);
							console.log(data.name, data.des, data.share_pic);
						}
						if (data.writers[0]) {
							this.writers = data.writers[0];
							this.writers.positionName = this.writers.title.name;
						}

						this.$nextTick(() => {
							const videoElements = this.$refs.richTextContainer.querySelectorAll('video');
							videoElements.forEach((videoElement) => {
								// 设置视频播放时间为0.5秒
								videoElement.setAttribute('poster', data.banner);
							});
						});

					}
				})
		},
		//文章推荐
		getRecommends() {
			const url = articleRecommend;
			let params = {
				article_id: this.article_id
			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.recommends = data;

					}
				})
		},
		//富文本视频第一帧作为封面
		videoCover(item, url) {
			const video = item; // 获取视频对象
			let canvas = document.createElement('canvas') //创建canvas
			video.src = url; // video的url地址
			const ctx = canvas.getContext("2d"); // 绘制2d
			video.crossOrigin = "anonymous"; // 解决跨域问题
			video.currentTime = 1; // 视频第一帧
			video.oncanplay = () => {
				canvas.width = video.clientWidth; // 视频宽度
				canvas.height = video.clientHeight; //视频高度
				// 利用canvas对象方法绘图
				ctx.drawImage(video, 100, 100, video.clientWidth, video.clientHeight);
				const coverImage = canvas.toDataURL('image/png');
				video.setAttribute('poster', coverImage);
			};
		},


		//查看全部
		checkAll() {
			this.$router.go(-1);
		},
		//发送评论
		sendComment() {
			if (this.userInfo) {
				if (this.content == '') {
					common.toast('请输入内容', 1000)
				} else {
					const url = ArticlesAddComment;
					const method = "POST";
					let params = {
						article_id: this.article_id,
						content: this.content
					}
					fetch(url, params, method)
						.then((res) => {
							if (res.code == 0) {
								common.toast('评论成功', 1000, '', () => {
									this.content = '';
									this.checkComments();
								})
							}
						})
				}
			} else {
				common.confirm('提示', '发表评论需要先登录哦', () => {
					// let url=window.location.href;
					// this.$router.push({
					// 	path:'/user/login',
					// 	query:{
					// 		url:url
					// 	}
					// })
				})
			}
		},
		//文章图片
		getArticleImages() {
			const url = ArticlesImage;
			const method = "POST";
			let params = {
				article_id: this.article_id,
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.articlesImageData = data;
						// this.commentList=data;
					}
				})
		},
		//查看评论
		checkComments() {
			const url = ArticlesComments;
			const method = "POST";
			let params = {
				article_id: this.article_id,
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.commentList = data;
					}
				})
		},
		//文章数量
		getArticlesLength() {
			const url = ArticlesLength;
			const method = 'POST';
			let params = {
				column_id: this.column_id
			};
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.articlesLength = data.articlenum;
					}
				})

		},
		//收藏文章
		collectArticles() {
			const url = ArticlesCollect;
			const method = 'POST';
			let params = {
				article_id: this.article_id
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						this.init();
					}
				})
		},
		//下载链接
		downloadLink(url) {
			var u = navigator.userAgent, app = navigator.appVersion;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
			var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			if (isAndroid) {
				window.location.href = url;
			}
			if (isIOS) {
				Dialog.alert({
					message: 'IOS系统用户如需下载请点击页面右上角“···”跳转到浏览器进行下载',
				}).then(() => {
					window.location.href = url;
				});
			}

		}
	}
}
</script>
<style lang="scss">
.exclusiveView-details {
	padding-bottom: 44px;

	.fixedHeader {
		position: fixed;
		top: 0px;
		width: 100%;
		background-color: $color-main;
		height: 40px;
		@include flex(row);
		justify-content: space-between;
		align-items: center;
		padding: 0 12px;

		b {
			font-size: 15px;
			color: #FFFFFF;
			letter-spacing: 0.53px;
		}

		span {
			font-size: 12px;
			color: rgba(255, 255, 255, 0.5);
			letter-spacing: 0.53px;
		}

		.checkBtn {
			background: #204EA1;
			border-radius: 2px;
			width: 70px;
			height: 28px;
			line-height: 28px;
			text-align: center;
			font-size: 14px;
			color: #FFFFFF;
			letter-spacing: 0.49px;
		}
	}

	.imagesWrap img {
		width: 100%;
		display: block;
	}

	.downloadLink {
		font-size: 14px;
		padding: 12px 10px;

		a {
			display: inline-block;
			color: red;
			margin: 0 5px;
			font-size: 16px;
		}
	}

	.introduction {
		padding: 10px 12px;
		// padding-top:54px;
		border-bottom: 1px solid #f1f2f4;

		.cover {
			margin-bottom: 14px;

			img {
				width: 100%;
				border-radius: 5px;
			}
		}

		h3 {
			font-size: 15px;
			line-height: 30px;
			color: $color-black;
		}

		.writerInfoWrap {
			/*padding:20px 0;*/
			/*border-bottom: 1px solid #eaeaea;*/
		}

		.writerInfo {
			padding: 10px 0;
			@include flex(row);
			align-items: center;

			img {
				margin-right: 10px;
				width: 34px;
				border-radius: 100%;
			}

			p {
				line-height: 25px;
				font-size: 13px;
				color: #666666;
				letter-spacing: 0.55px;
			}
		}

		.time {
			margin-top: 5px;
			@include flex(row);
			justify-content: space-between;
			align-items: center;

			p {
				color: $color-gray;
				font-size: 12px;
			}

			.operation {
				@include flex(row);
				align-items: center;
			}

			i {
				margin-right: 20px;
				color: $color-black;
				font-size: 18px;
			}

			.attention {
				font-size: 11px;
				color: $color-black;
				padding: 3px 11px;
				border: 1px solid #d3d3d3;
				border-radius: 2px;
			}

		}

	}

	.articleContent {
		padding: 14px 12px;
		border-top: 1px solid #eaeaea;

		img {
			width: 100% !important;
			height: auto !important;
		}
	}

	.comment {
		padding: 0 12px;

		h3 {
			line-height: 40px;
			font-size: 15px;
			color: $color-black;
			letter-spacing: 0.13px;
		}

		.comment-item {
			border-top: 1px solid #bfbfbf;
			padding: 18px 0px;
			@include flex(row);

			img {
				width: 40px;
				height: 40px;
				border-radius: 100%;
			}

			.commentContent {
				margin-left: 12px;
				flex: 1;

				span {
					font-size: 14px;
					color: $color-black;
				}

				p {
					line-height: 25px;
					font-size: 12px;
					color: $color-gray;
				}
			}

			.content {
				margin-top: 5px;

				p {
					color: $color-black;
					font-size: 14px;
					letter-spacing: 0.12px;
					text-align: justify;
				}
			}

		}
	}

	.fixedImg {
		position: fixed;
		bottom: 60px;
		width: 100%;
		@include flex(row);
		justify-content: space-between;
		padding: 0 22px;

		img {
			width: 50px;
		}
	}

	.comment-input {
		position: fixed;
		bottom: 0px;
		width: 100%;
		box-sizing: border-box;
		height: 44px;
		padding: 5px 15px;
		@include flex(row);
		align-items: center;
		background-color: #f4f4f4;

		input {
			line-height: 34px;
			padding-left: 5px;
			flex: 1;
			width: 80%;
			border: 0px;
			font-size: 15px;
			color: #000;
		}

		button {
			margin-left: 10px;
			padding: 0 12px;
			height: 28px;
			border: 0px;
			line-height: 28px;
			text-align: center;
			background-color: $color-main;
			font-size: 14px;
			color: #fff;
		}
	}

	.recommends {
		margin: 20px;

		p {
			text-align: center;
			font-size: 15px;
			line-height: 0.8rem;
		}

		a {
			text-decoration: underline;
			font-size: 13px;
			line-height: 0.6rem;
			color: darkblue;
		}
	}
}

.video-js {
	max-width: 100% !important;
	margin: 0 auto;
	width: 100% !important;
	min-height: 200px;

	.vjs-big-play-button {
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: auto;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/ExclusiveView/Details.vue